import * as React from "react";
import {Fragment} from "react";

class Frame extends React.Component {

	constructor(props) {
		super(props);
	}

	shouldComponentUpdate(nextProps, nextState, nextContext) {
		return false;
	}

	render() {

		const {background, shortcut, single} = this.props;

		const pathAndFileName = () => {
			if(shortcut === 'MK+TLC') {
				return 'Topline_Cassette_18032024/Topline_Cassette.html';
			}
			if(shortcut === 'MK+TRLX') {
				return 'Smartbox_13032023/Smartbox.html';
			}
			if(shortcut === 'MK+TRLA') {
				return 'Trendline_Artbox_18032024/Trendline_Artbox.html';
			}
			if(shortcut === 'MK+TRLC') {
				return 'Trendline_Cassette_18032024/Trendline_Cassette.html';
			}
			if(shortcut === 'MK+TRL') {
				return 'Trendline_TRL_18032024/Trendline_TRL.html';
			}
			if(shortcut === 'MK+SLC') {
				return 'Swingline_Cassette_29052023/Swingline_Cassette.html';
			}
			if(shortcut === 'MK+SL') {
				return 'Swingline_SL/Swingline_SL.html';
			}
			if(shortcut === 'MK+TLP') {
				return 'Topline_Plus_24112023/Topline_Plus.html';
			}
			if(shortcut === 'MK+TL') {
				return 'Topline_TL_07112023/Topline_TL.html';
			}

			return '';
		}

		return (
			<Fragment>

				{single &&
					<Fragment>
						<div dangerouslySetInnerHTML={{__html: '<style> html, body, #root, .col { height:100%; overflow:hidden; } </style>'}} />
					</Fragment>
				}

				<iframe id="modelFrame" src={`/_Resources/Static/Packages/WOUNDWO.Configurator/${pathAndFileName()}`} frameBorder="0" className={single ? 'iframe-single' : 'iframe'} style={{backgroundImage: (background ? `url('${background}')` : false), backgroundRepeat: 'no-repeat', backgroundPosition: 'center center', backgroundSize: '800px'}} />
				{/*<iframe id="modelFrame" src="/_Resources/Static/Packages/WOUNDWO.Configurator/Smartbox_13032023/Smartbox.html" frameBorder="0" className="iframe" style={{backgroundImage: (background ? `url('${background}')` : false), backgroundRepeat: 'no-repeat', backgroundPosition: 'center center', backgroundSize: '100%'}} />*/}
				{/*<iframe src="/_Resources/Static/Packages/WOUNDWO.Configurator/Smartbox_13032023/Smartbox.html" frameBorder="0" className="iframe" />*/}
			</Fragment>
		);
	}
}

export default Frame;
